export const SENTIMENT_TYPE = {
  POSITIVE: {
    key: 'POSITIVE',
    id: 1,
    name: 'alerts.sentimentType.POSITIVE',
  },
  NEGATIVE: {
    key: 'NEGATIVE',
    id: 2,
    name: 'alerts.sentimentType.NEGATIVE',
  },
  INFORMATIVE: {
    key: 'INFORMATIVE',
    id: 3,
    name: 'alerts.sentimentType.INFORMATIVE',
  },
}

export const SENTIMENT_COLOR_BY_ID = {
  [SENTIMENT_TYPE.POSITIVE.id]: '#3DA967',
  [SENTIMENT_TYPE.NEGATIVE.id]: '#E0505B',
  [SENTIMENT_TYPE.INFORMATIVE.id]: '#0553A5',
}

export const SENTIMENT_ICON_BY_ID = {
  [SENTIMENT_TYPE.POSITIVE.id]: 'icon-arrow-up-circle',
  [SENTIMENT_TYPE.NEGATIVE.id]: 'icon-arrow-down-circle',
  [SENTIMENT_TYPE.INFORMATIVE.id]: 'icon-info-circle',
}

export const SUBJECT_TYPE = {
  COMPANY: {
    key: 'COMPANY',
    id: 1,
    name: 'alerts.subjectType.COMPANY',
  },
  INDUSTRY: {
    key: 'INDUSTRY',
    id: 2,
    name: 'alerts.subjectType.INDUSTRY',
  },
  MACROECONOMIC: {
    key: 'MACROECONOMIC',
    id: 3,
    name: 'alerts.subjectType.MACROECONOMIC',
  },
}

export const RULES_TYPE = {
  EVENT_RULES: 'EVENT_RULES',
  SCORE_RULES: 'SCORE_RULES',
  FINANCIAL_RULES: 'FINANCIAL_RULES',
  FOLLOWING_LIST: 'FOLLOWING_LIST',
}

export const GROUP_ID = {
  [RULES_TYPE.EVENT_RULES]: 1,
  [RULES_TYPE.SCORE_RULES]: 2,
  [RULES_TYPE.FINANCIAL_RULES]: 3,
  [RULES_TYPE.FOLLOWING_LIST]: 4,
}
